<template>
  <div>
    <div class="left-panel">
      <div class="heading">
        <span class="cons-name">Invoice {{ invoiceId }}</span>
      </div>

      <div class="body">
         <div :class="{'collapsible':true, 'collapse':!contentShow.invoiceInfo}">
          <div class="head" @click="contentShow.invoiceInfo = !contentShow.invoiceInfo">
            <i class="fa fa-minus-circle" v-show="contentShow.invoiceInfo"></i>
            <i class="fa fa-plus-circle" v-show="!contentShow.invoiceInfo"></i>
            <span>Invoice Information</span>
          </div>

          <div class="content">
            <div class="medium-6 column margin-B-m">
              <div class="data-field">
                <div class="label">Invoice Start Date</div>
                <div class="value">
                  <span>{{ startDate }}</span>
                </div>
              </div>
            </div>

            <div class="medium-6 column margin-B-m">
              <div class="data-field">
                <div class="label">Invoice End Date</div>
                <div class="value">
                  <span>{{ endDate }}</span>
                </div>
              </div>
            </div>

            <div class="medium-12 column margin-B-m" v-if="false">
              <div class="data-field">
                <div class="label">PDF File</div>
                <div class="value">
                  <a :href="pdfFile" target="_blank">View attached file</a>
                </div>
              </div>
            </div>

            <div class="medium-6 column margin-B-m padding-R-m">
              <div class="data-field">
                <div class="label">Due Date</div>
                <div class="value">
                  <span v-if="!showEditField">{{ dueDate }}</span>
                  <datepicker :format="calendarFormat" v-else
                    class="datepicker inline small" v-model="dueDateField"
                    :disabled-picker="statusLoading" :disabled="disabledDueDate"></datepicker>
                </div>
              </div>
            </div>

            <div class="medium-6 column end margin-B-m">
              <div class="data-field">
                <div class="label">Status</div>
                <div class="value">
                  <div v-if="showEditField">
                    <select v-model="statusField" :disabled="statusLoading" class="margin-B-s">
                      <option value="paid">Paid</option>
                      <option value="unpaid">Unpaid</option>
                      <option value="canceled">Canceled</option>
                    </select>
                  </div>
                  <span :class="['status', status]" v-else>{{ status }}</span>
                </div>
              </div>
            </div>

            <div class="medium-12 column margin-B-m" v-if="status !== 'canceled'">
              <span class="button cta xsmall edit" @click="showEditField = true" v-show="!showEditField">Edit</span>
              <div :class="{'button cta error xsmall':true, 'disabled':statusLoading}"
                @click="showEditField = false" v-show="showEditField">Cancel</div>
              <div :class="{'button cta success xsmall':true, 'disabled':statusLoading}"
                @click="updateFields" v-show="showEditField">Save</div>
            </div>

            <div class="clear"></div>
          </div>
        </div>

        <div :class="{'collapsible':true, 'collapse':!contentShow.accountInfo}">
          <div class="head" @click="contentShow.accountInfo = !contentShow.accountInfo">
            <i class="fa fa-minus-circle" v-show="contentShow.accountInfo"></i>
            <i class="fa fa-plus-circle" v-show="!contentShow.accountInfo"></i>
            <span>Corporate Profile</span>
          </div>

          <div class="content">
            <!-- <div class="logo-box">
              <div class="img-hover-box">
                <img :src="corporateInfo.logo" v-if="corporateInfo.logo" />
              </div>
            </div> -->

            <div class="medium-12 column margin-B-m">
              <div class="data-field">
                <div class="label">Coporate Name</div>
                <div class="value">
                  <span>{{ corporateInfo.name }}</span>
                </div>
              </div>
            </div>

            <div class="medium-8 column margin-B-m">
              <div class="data-field">
                <div class="label">Email</div>
                <div class="value">
                  <span>{{ corporateInfo.email }}</span>
                </div>
              </div>
            </div>

            <div class="medium-4 column margin-B-m">
              <div class="data-field">
                <div class="label">Mobile</div>
                <div class="value">
                  <span>{{ corporateInfo.mobile }}</span>
                </div>
              </div>
            </div>

            <div class="clear"></div>
          </div>
        </div>
      </div>

    </div>

    <div class="toggle-mobile" @click="showRecords = !showRecords">
      <span v-if="!showRecords">Show Records <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Records <i class="fa fa-chevron-down"></i></span>  
    </div>

    <div :class="['right-panel', showRecords ? 'mobile-right-panel' : '']">
      <table>
        <thead>
          <th>Completion Date</th>
          <th>Passenger Name</th>
          <th>RSVP ID</th>
          <th>Pickup/Dropoff</th>
          <th>Amount</th>
        </thead>
        <tbody>
          <tr v-for="trx in transactions.list" v-show="transactions.list.length > 0" :key="trx.id">
            <td>{{ trx.completedDate }}</td>
            <td>{{ trx.passenger }}</td>
            <td><a :href="'/#/reservation/' + trx.id" target="_blank">{{ trx.id }}</a></td>
            <td>{{ trx.pickup }} <br/> {{ trx.dropoff }}</td>
            <td>${{ trx.total }}</td>
          </tr>

          <tr v-show="transactions.loading">
            <td colspan="5" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              Getting your invoices...
            </td>
          </tr>

          <tr v-show="transactions.list.length === 0 && !transactions.loading">
            <td colspan="5" class="table-block">No Invoices as of yet.</td>
          </tr>
        </tbody>
      </table>

      <div class="cards-mobile">
        <div v-show="transactions.loading">
          <i class="fa fa-circle-notch fa-spin"></i>
          Getting your invoices...
        </div>

        <div v-show="transactions.list.length === 0 && !transactions.loading" style="margin-top: 50px;">
          No Invoices as of yet.
        </div>

        <div class="card" v-for="trx in transactions.list" v-show="transactions.list.length > 0" :key="trx.id">
          <div class="title">
            <div class="label">Completion Date: </div>
            <div class="value">{{trx.completedDate}}</div>
          </div>
          <div class="title">
            <div class="label">Passenger Name: </div>
            <div class="value">{{trx.passenger}}</div>
          </div>
          <div class="title">
            <div class="label">RSVP ID: </div>
            <div class="value"><a :href="'/#/reservation/' + trx.id" target="_blank">{{ trx.id }}</a></div>
          </div>
          <div class="title">
            <div class="label">Pickup: </div>
            <div class="value">{{trx.pickup}}</div>
          </div>
          <div class="title">
            <div class="label">Dropoff: </div>
            <div class="value">{{trx.dropoff}}</div>
          </div>
          <div class="title">
            <div class="label">Amount: </div>
            <div class="value">${{trx.total}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import ApiCorporateProfile from '@/modules/api/corporate/profile'
import ApiInvoice from '@/modules/api/corporate/invoice'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'invoice',
  data () {
    return {
      contentShow: {
        accountInfo: true,
        invoiceInfo: true
      },
      startDate: '',
      endDate: '',
      today: moment(),
      dueDate: '',
      dueDateField: '',
      status: '',
      statusField: '',
      showEditField: false,
      statusLoading: false,
      pdfFile: '',
      transactions: {
        list: [],
        loading: false
      },
      showRecords: false
    }
  },
  components: { datepicker },
  computed: {
    corporateId () { return this.$route.params.id },
    invoiceId () { return this.$route.params.invoiceId },
    corporateInfo () { return this.$store.state.corporate.profile.info },
    disabledDueDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
  },
  methods: {
    resetInfo () {
      this.startDate = ''
      this.endDate = ''
      this.dueDate = ''
      this.status = ''
      this.showEditField = false
      this.statusLoading = false
      this.pdfFile = ''
      this.transactions = {
        list: [],
        loading: false
      }
    },
    getInvoiceData () {
      let self = this
      self.resetInfo()

      ApiInvoice.getInvoiceData(self, {
        corporateId: self.corporateId,
        invoiceId: self.invoiceId
      }, res => {
        if (!res.error) {
          let dbFormat = 'YYYY-MM-DD'
          let boFormat = 'MM/DD/YYYY'
          self.startDate = moment(res.startDate, dbFormat).format(boFormat)
          self.endDate = moment(res.endDate, dbFormat).format(boFormat)
          self.dueDate = moment(res.dueDate, dbFormat).format(boFormat)
          self.dueDateField = self.dueDate
          self.status = res.status
          self.statusField = res.status
          self.pdfFile = res.fileUrl

          self.$store.commit('corporate/setInvoiceDateFrom', self.startDate)
          self.$store.commit('corporate/setInvoiceDateTo', self.endDate)
          self.$store.commit('corporate/setInvoiceDueDate', self.dueDate)

          self.getInvoiceTransaction()
        } else {
          self.$router.push('/accessdenied')
        }
      })
    },
    getInvoiceTransaction () {
      let self = this
      ApiCorporateProfile.getAllTransactions(self, self.corporateId, res => {
        if (!res.error) {
          res.list.forEach(data => {
            let pickup = `${data.pickupLocation.addressLine1}, ${data.pickupLocation.city}, ${data.pickupLocation.state}`
            let dropoff = `${data.dropoffLocation.addressLine1}, ${data.dropoffLocation.city}, ${data.dropoffLocation.state}`
            let total = parseFloat(data.breakdown.fare + data.breakdown.pickupFee + data.breakdown.tip + data.breakdown.airportFee + data.breakdown.travelInsurance)
            total -= data.credits
            self.transactions.list.push({
              id: data.ID,
              completedDate: moment(data.complete, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              passenger: data.guest.firstName + ' ' + data.guest.lastName,
              pickup: pickup,
              dropoff: dropoff,
              total: total.toFixed(2)
            })
          })
        }
      })
    },
    getCorporateData () {
      let self = this
      ApiCorporateProfile.getInfo(self, self.corporateId, res => {
        if (!res.error && res.list.length) {
          let info = res.list[0]
          self.$store.commit('corporate/setProfile', {
            id: info.id,
            consId: info.custContactID,
            logo: info.logoUrl,
            username: info.username,
            password: info.password,
            name: info.name,
            email: info.contactEmail,
            color: info.corporateColor,
            mobile: info.contactPhone,
            website: info.corporateWebsiteUrl,
            cardOwner: '',
            creditCard: '',
            cardExpiration: '',
            cardCVV: '',
            billingAddress1: info.billingAddress1,
            billingAddress2: info.billingAddress2,
            billingCity: info.billingCity,
            billingState: info.billingState,
            billingZip: info.billingZip,
            biilingCountry: info.billingCountry,
            stripeUrl: info.customer.customerURL,
            active: info.active === 1
          })
        } else {
          self.$router.push('/accessdenied')
        }
      })
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    updateFields () {
      let self = this
      if (self.statusLoading) { return }
      
      self.statusLoading = true
      ApiInvoice.updateFields(self, {
        corporateId: self.corporateId,
        invoiceId: self.invoiceId,
        status: self.statusField,
        dueDate: moment(self.dueDateField).format('YYYY-MM-DD')
      }, res => {
        self.statusLoading = false
        if (!res.error) {
          self.showEditField = false
          self.status = res.status
          self.dueDate = res.dueDate
        }
      })
    }
  },
  watch: {
    corporateId: function (value) {
      this.getInvoiceData()
      this.getCorporateData()
    },
    invoiceId: function (value) {
      this.getInvoiceData()
      this.getCorporateData()
    }
  },
  mounted () {
    this.getInvoiceData()
    this.getCorporateData()
  }
}

</script>

<style lang="scss" scoped>
.margin-B-s{ margin-bottom: 5px; }
.margin-B-m{ margin-bottom: 10px; }
.margin-T-l{ margin-top: 15px; }
.padding-R-m{ padding-right: 10px; }
.clear{ clear:both; }

.left-panel{
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 500px;
  height: 100%;
  box-shadow: 2px 0 4px rgba(0,0,0,0.2);
  background-color: #F4F8F9;
  overflow-y: auto;

  .heading{
    padding-left: 50px; 
    height: 50px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    padding: 10px 0 10px 50px;
    border-bottom: 1px solid #ccc;

    span{
      padding: 0 5px 0 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
      display: inline-block;
    }
  }

  .body{
    padding: 20px;
    background: #fafafa;
  }
}

.collapsible{
  margin-bottom: 5px;

  .head{
    color: #0D79F2;
    margin-bottom: 2px;
    cursor: pointer;
    text-transform: uppercase;

    i{ margin-right: 5px; }
    span { font-weight: 600; }
  }
  .content{
    margin-left: 6px;
    padding: 5px 0 5px 15px;
    border-left: 2px solid #ddd;
    max-height: 800px; /* define precise max-height for more smoother transition */
    height: auto;
    transition:all 0.35s ease-out;

    .field-row{ margin-bottom: 15px; }
    .field-row:last-child{ margin-bottom: 0; }
  }
  &.collapse .content{
    max-height: 0;
    padding: 0 15px;
    overflow: hidden;
  }
}

.logo-box{
  text-align: center;
  padding: 0 20px 20px;

  img{
    max-width: 200px;
    max-height: 200px;
    cursor: pointer;
    transition: .2s ease all;
  }
}

.data-field{
  font-weight: 600;
  .label{
    color: #888;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 120%;
  }
  .value{
    font-size: 17px;
    color: #555;

    a{
      text-decoration: underline;
      cursor: pointer;
      font-size: 13px;
    }
  }
  select{
    border: 1px solid #ddd;
    padding: 5px;
    color: #333;
    height: 35px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
}

.status{
  font-size: 12px;
  padding: 2px 6px;
  color: #fff;
  background:#777;
  display: inline-block;
  text-transform: uppercase;
  border-radius: 2px;

  &.unpaid{ background: #de5050; }
  &.paid{ background: #47bd63; }
}

.edit{
  display: inline-block;
  width: 100px;
  cursor: pointer;
  color: #0D79F2;
  font-size: 14px;
}

.right-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: calc(100% - 500px);
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #d5d5d5;
  overflow-y: hidden;
  padding: 20px 40px;

  .heading{
    font-size:24px;
    padding: 10px 20px;
  }

  .tab{
    background: #d5d5d5;
    & .active{ background: #ededed; }
  }
  .tab-contents{ background: #ededed; }
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{
            color: #ccc;
          }
        }
      }
    }
  }
}

.cards-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .left-panel {
    width: 100%;
    padding-bottom: 100px;
    .heading {
      .switch {
        display: block;
        padding-top: 5px;
        padding-left: 10px;
        padding-right: 50px;
      }

      .prov-options {
        position: absolute;
        right: 0;
        top: 15px;
      }
    }

    .tab {
      margin: 35px 0 0;
      display: flex;
      overflow-x: scroll;

      li {
        width: auto;
      }
    }
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }

  .right-panel {
    z-index: 1;
    width: 100%;
    top: 100%;
    transition: all 0.3s ease;

    table {
      display: none;
    }

    &.mobile-right-panel {
      top: 0;
      z-index: 2;

      .tab {
        margin-top: 70px;
        display: flex;
        overflow-x: scroll;
      }

      .tab-contents {
        width: 100%;
        height: calc(100vh - 142px);
        overflow-y: scroll;
        .tab-content {
          padding-bottom: 60px;

          &.history-panel {
            padding: 0;
            padding-top: 20px;
            padding-bottom: 60px;
          }

        }
        .fixed-footer {
          width: 100%;
          bottom: 45px;
          background: #fff;
          color: #000;
          border-top: 1px solid #aaa;
        }
      }

      .logs-panel {
        width: 100%;
      }
    }
  }

  .fix-buttons {
    width: 100%;
    bottom: 45px;
    a {
      margin: 0 auto;
    }
  }

  .toggle-panel .heading {
    display: flex;
    justify-content: center;
  }

  .cards-mobile {
    display: block;
    margin-top: 50px;
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      display: flex;
      flex-direction: column;

      .info {
        width: 100%;
        padding-left: 10px;
      }

      > div {
        margin-bottom: 3px;
        width: 100%;
      }

      .email-logo {
        img {
          max-width: 100px;
          max-height: 100px;
        }
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    
        .time {
          font-size: 12px;
          color: #777;
          word-spacing: 5px;
        }

        .amount {
          font-weight: 900;
          font-size: 20px;
          a {
            text-decoration: none;
          }
        }
      }

      .credit-card {
        font-weight: 900;
      }

      .btn-action {
        display: flex;
        justify-content: center;
        padding: 20px 10px 0;
        a {
          width: 50%;
        }
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 3px;

        &.pkg-div {
          justify-content: space-between;
        }

        .pkg-type {
          display: flex;
        }

        input {
          margin-right: 5px;
        }

        &.view {
          justify-content: space-between;
          padding-top: 7px;
          padding-bottom: 5px;
          border-top: 1px solid #eee;
        }

        .refer {
          display: flex;
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/Invoice.vue